import { Pipe, PipeTransform } from '@angular/core';

/**
 * This pipe can be used to round numbers up with desired precision, usually amount of decimals.
 */
@Pipe({
  name: 'qmRound'
})
export class QmRoundPipe implements PipeTransform {
  /**
   *
   * @param value
   * @param precision - negative values indicate rounding up to nearest ten, hundred, thousand, etc
   * and positive values indicate amount of decimals after dot.
   * @returns {number}
   */
  transform(value: number, precision: number): number {
    const factor = Math.pow(10, precision);
    const tempNumber = value * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
  }

}
